import React, { useEffect, useState } from 'react';
import { defineMessages } from 'react-intl';
import notFoundImage from '@assets/images/avatar-default.png';
import CropImageField from '@components/common/form/CropImageField';
import { AppConstants } from '@constants';
import apiConfig from '@constants/apiConfig';
import useBasicForm from '@hooks/useBasicForm';
import useFetch from '@hooks/useFetch';
import useTranslate from '@hooks/useTranslate';
import { TextField } from '@itz/react-cms-element';
import { commonMessage } from '@locales/intl';
import { handleRemoveImage } from '@utils';
import { Card, Form } from 'antd';

const message = defineMessages({
    objectName: 'group permission',
});

const ProfileForm = (props) => {
    const translate = useTranslate();
    const { formId, dataDetail, onSubmit, setIsChangedFormValues, actions, isAdmin } = props;
    const [ imageUrl, setImageUrl ] = useState(null);
    const [ logoUrl, setLogoUrl ] = useState(null);
    const { execute: executeUpFile } = useFetch(apiConfig.file.upload);

    const { form, mixinFuncs, onValuesChange } = useBasicForm({
        onSubmit,
        setIsChangedFormValues,
    });
    const uploadFile = (file) => {
        executeUpFile({
            data: {
                type: 'LOGO',
                file: file,
            },
            onCompleted: (response) => {
                if (response.result === true) {
                    setImageUrl(response.data.filePath);
                    setIsChangedFormValues(true);
                }
            },
            onError: (error) => {},
        });
    };

    const uploadLogoFile = (file, onSuccess, onError) => {
        executeUpFile({
            data: {
                type: 'AVATAR',
                file: file,
            },
            onCompleted: (response) => {
                if (response.result === true) {
                    // onSuccess();
                    setLogoUrl(response.data.filePath);
                }
            },
            onError: (error) => {},
        });
    };

    useEffect(() => {
        form.setFieldsValue({
            ...dataDetail,
            city: dataDetail?.city,
            country: dataDetail.info?.country,
            jobTitle: dataDetail.info?.jobTitle,
            department: dataDetail.info?.department,
            employeeId: dataDetail.info?.employeeId,
            postalCode: dataDetail.info?.postalCode,
            email: dataDetail?.email,
        });
        setImageUrl(isAdmin() ? dataDetail?.avatar : dataDetail?.avatarPath);
        setLogoUrl(dataDetail?.logoPath);
    }, [ dataDetail ]);

    const handleFinish = (values) => {
        mixinFuncs.handleSubmit({
            fullName: values.fullName,
            oldPassword: values.oldPassword,
            password: values.password,
            avatarPath: imageUrl,
            logo: logoUrl,
            zipCode: values.zipCode,
            city: values.city,
            address: values.address,
            taxNumber: values.taxNumber,
            email: values.email,
            phone: values.phone,
        });
    };

    return (
        <Card className="card-form" bordered={false} style={{ minHeight: 'calc(100vh - 190px)' }}>
            <Form
                style={{ width: '50%' }}
                labelCol={{ span: 8 }}
                id={formId}
                onFinish={handleFinish}
                form={form}
                layout="horizontal"
                onValuesChange={onValuesChange}
            >
                <CropImageField
                    label={translate.formatMessage(commonMessage.avatar)}
                    name="avatarPath"
                    imageUrl={imageUrl && `${AppConstants.contentRootUrl}${imageUrl}`}
                    aspect={1 / 1}
                    uploadFile={uploadFile}
                    handleRemoveImage={() => handleRemoveImage(setImageUrl, form)}
                />
                <TextField label={translate.formatMessage(commonMessage.username)} name="username" disabled required/>
                <TextField label={translate.formatMessage(commonMessage.fullName)} name="fullName" required />
                <TextField label={translate.formatMessage(commonMessage.email)} name="email" />

                {!isAdmin() && (
                    <>
                        <TextField name="phone" label={translate.formatMessage(commonMessage.phoneNumber)} required />
                        <TextField name="taxNumber" label={translate.formatMessage(commonMessage.taxNumber)} required />
                        <TextField name="zipCode" label={translate.formatMessage(commonMessage.zipCode)} required />
                        <TextField name="city" label={translate.formatMessage(commonMessage.city)} required />
                        <TextField
                            name="address"
                            label={translate.formatMessage(commonMessage.email)}
                            type="textarea"
                            required
                        />
                        <CropImageField
                            label={translate.formatMessage(commonMessage.logoPath)}
                            name="logoPath"
                            imageUrl={logoUrl && `${AppConstants.contentRootUrl}${logoUrl}`}
                            aspect={1 / 1}
                            required
                            uploadFile={uploadLogoFile}
                            handleRemoveImage={() => handleRemoveImage(setLogoUrl, form)}
                        />
                    </>
                )}

                <TextField
                    type="password"
                    label={translate.formatMessage(commonMessage.currentPassword)}
                    required
                    name="oldPassword"
                />
                <TextField
                    type="password"
                    label={translate.formatMessage(commonMessage.newPassword)}
                    name="password"
                    rules={[
                        {
                            validator: async () => {
                                const isTouched = form.isFieldTouched('newPassword');
                                if (isTouched) {
                                    const value = form.getFieldValue('newPassword');
                                    if (value.length < 6) {
                                        throw new Error(translate.formatMessage(commonMessage.validatePassword));
                                    }
                                }
                            },
                        },
                    ]}
                />
                <TextField
                    type="password"
                    label={translate.formatMessage(commonMessage.confirmPassword)}
                    rules={[
                        {
                            validator: async () => {
                                const password = form.getFieldValue('newPassword');
                                const confirmPassword = form.getFieldValue('confirmPassword');
                                if (password !== confirmPassword) {
                                    throw new Error(translate.formatMessage(commonMessage.passwordNotMatch));
                                }
                            },
                        },
                    ]}
                />
                <div className="footer-card-form">{actions}</div>
            </Form>
        </Card>
    );
};

export default ProfileForm;
